var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#FF5B8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6677 10.5C23.4021 10.7015 23.9804 11.2953 24.1767 12.0493C24.5333 13.4158 24.5333 16.2671 24.5333 16.2671C24.5333 16.2671 24.5333 19.1183 24.1767 20.485C23.9804 21.239 23.4021 21.8327 22.6677 22.0343C21.3369 22.4005 16 22.4005 16 22.4005C16 22.4005 10.6631 22.4005 9.33218 22.0343C8.59783 21.8327 8.0195 21.239 7.82323 20.485C7.46667 19.1183 7.46667 16.2671 7.46667 16.2671C7.46667 16.2671 7.46667 13.4158 7.82323 12.0493C8.0195 11.2953 8.59783 10.7015 9.33218 10.5C10.6631 10.1338 16 10.1338 16 10.1338C16 10.1338 21.3369 10.1338 22.6677 10.5ZM14.4 13.8671V19.2004L18.6667 16.5338L14.4 13.8671Z",
    fill: "#F6A9BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3f7718ef043008ea1e113944d82979c3.svg";
export { ForwardRef as ReactComponent };